export interface FaqItem {
  question: string
  answer: string
}

export const faqs: FaqItem[] = [
  {
    question: '¿Funciona para todas las edades?',
    answer:
      'Sí. El MEGAPACK incluye sesiones para Primaria y Secundaria. Cada volumen está dividido por niveles de progresión motriz, no por edad, así que lo adaptas al grupo que tengas enfrente.',
  },
  {
    question: '¿Es 100% PDF?',
    answer:
      'Sí, todo imprimible. Lo descargas en la computadora, la tableta o el celular y lo usas sin internet (recomendamos descargarlo una vez). El acceso es de por vida.',
  },
  {
    question: '¿Cuánto tiempo toma implementarlo?',
    answer:
      'Está listo para usar desde el primer día: abres el volumen, eliges una sesión, entras a clase y enseñas. No hay curva de aprendizaje.',
  },
  {
    question: '¿Sirve si enseño en una escuela sin presupuesto?',
    answer:
      'Perfectamente. El 40% de nuestros usuarios enseña en escuelas públicas de Latinoamérica y España sin presupuesto. Hay un volumen entero de juegos sin material: está diseñado para esa realidad.',
  },
  {
    question: '¿Sirve para cualquier país o programa escolar?',
    answer:
      'Sí. El material está en español neutro y las progresiones son pedagógicas, no administrativas: encajan con el programa oficial de cualquier país de habla hispana, en el hemisferio norte o sur.',
  },
  {
    question: '¿En qué moneda pago?',
    answer:
      'El precio es de 19 USD y el cobro se procesa en tu moneda local con tarjeta o los medios de pago disponibles en tu país. Es un pago único, sin suscripciones.',
  },
  {
    question: '¿Qué pasa si no me gusta?',
    answer:
      'Reembolso total en 7 días, sin preguntas. Igual te lo decimos: la tasa de devolución es menor al 0,5% porque el sistema funciona.',
  },
  {
    question: '¿Hay actualizaciones o soporte?',
    answer:
      'Acceso de por vida a todo lo que agreguemos. Además entras a un grupo exclusivo de docentes donde compartimos recursos, dudas y mejoras.',
  },
]
